import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=61f0216e&scoped=true&"
import script from "./ModalWarning.vue?vue&type=script&lang=js&"
export * from "./ModalWarning.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarning.vue?vue&type=style&index=0&id=61f0216e&prod&lang=scss&"
import style1 from "./ModalWarning.vue?vue&type=style&index=1&id=61f0216e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0216e",
  null
  
)

export default component.exports